<template>
<div id="vertical-list">
    <div class="vert-wrap">
        <div class="rec-list-wrap">
            <ul v-if="store_list.length > 0">
                <template v-for="(store, index) in store_list">
                    <li class="rec-cafe-list more-load" :id="'elem_'+index" @click="goStoreDetail(store.store_id, store.store_name,index)" :key="index">
                        <a href="javascript:void(0)">
                            <div class="rec-cafe">
                                <template v-if="store.photograph_path == 'images/MOBILE/defalut.jpg'">
                                     <div class="rec-cafe-img" :style="{background: 'url('+host_url+'/'+store.photograph_path+') no-repeat center center/cover', 'background-size':'60%' }"></div>
                                </template>
                                <template v-else>
                                     <div class="rec-cafe-img" :style="{background: 'url('+host_url+'/'+store.photograph_path+') no-repeat center center/cover'}"></div>
                                </template>
                               
                                <div class="rec-cafe-info">
                                    <span class="rec-cafe-title">{{store.store_name}}</span>
                                    <span class="rec-cafe-location">{{store.address}}<span class="rec-cafe-subway">{{store.location_info}}</span></span>
                                    <span class="rec-cafe-length" v-if="page_type == '/nearby'">{{store.distance}}Km</span>
                                </div>
                            </div>
                        </a>
                    </li>
                </template>
            </ul>

        </div>
        <div class="btn-more" @click="more_view($event)" v-if="store_list.length > (more_num-1) && more_btn">
            <!-- <a href="javascript:test(0);"> -->
            <a>
                <span>
                    <!-- 코드 추가 - 2020-12-21 -->
                    <span>+</span> &nbsp;더보기</span>
                <!--  -->
            </a>
        </div>
        <div class="noresult" v-if="store_list.length == 0 && result_show">
            <span>검색 조건과 일치한 내용이 없습니다.&nbsp;&nbsp;<img src="../../assets/images/error.png" alt="error"></span>
        </div>
    </div>

</div>
</template>

<script>
import * as config from '../../js/config';
import common from '../../js/common';
import EventBus from '../../js/event_bus';

export default {
    name: "vertical-list",
    props: ['distance'],
    data() {
        return {
            host_url: '',
            store_list: [],
            store_verify: [],
            params: {},
            more_count: 0,
            more_num: 5,
            more_btn: true,
            result_show: false,
            page_type: this.$route.path
        }
    },
    mounted() {
        this.$nextTick(function () {
            this.host_url = config.HOST;
        });
    },
    created() {
      
    },
    destroyed() {
        this.more_count = 0;
    },
    methods: {
        more_view(e) {
            this.$store.commit('setLoading', {
                value: true
            });
            this.more_count += this.more_num;
            console.log('count'+this.more_count+'more_num'+this.more_num);
            this.params.more_count = this.more_count;
            console.log('more_count: '+this.more_count);
            var data = this.params;
            common.getData(data.type, data,
                (response) => {
                    for (let i = 0; i < response.length; i++) {
                        if (response[i].photograph_path == null) {
                            response[i].photograph_path = 'images/MOBILE/defalut.jpg';
                        }
                        this.store_list.push(response[i]);
                    }

                    if (response.length < this.more_num) {
                        if ($('.more-load:hidden').length == 0) {
                            $('.btn-more').text('').addClass('no-more');
                            this.more_btn = this.store_list.length > (this.more_num - 1) ? false : true;
                        }
                    }

                })
        },
        initComponent(params) {
            this.store_list = [];
            var getParams = common.getParams();
            if (typeof getParams != 'undefined') {
                if (Object.keys(getParams).length !== 0 && typeof getParams.store_list != 'undefined') {
                    this.store_list = getParams.store_list;
                    this.store_list.forEach(item => {
                        this.store_verify.push(item.store_id);
                    });
                    this.more_count = getParams.more_count;
                    this.more_btn = getParams.more_btn;

                    this.params = getParams;
                    common.setParams({});
                    this.$store.commit('setLoading', {
                        value: false
                    });
                } else {
                    this.more_count = 0;
                    this.more_btn = true;
                    params.more_count = this.more_count;
                    this.params = params;
                    this.getData();
                }
            } else {
                params.more_count = this.more_count;
                this.params = params;
                this.getData();
            }
        },
        getData() {
            var data = this.params;
            common.getData(data.type, data,
                (response) => {
                    if (response.length > 0) {
                        this.result_show = false;
                        this.store_list = response;
                        for (let i = 0; i < this.store_list.length; i++) {
                            if (this.store_list[i].photograph_path == null) {
                                this.store_list[i].photograph_path = 'images/MOBILE/defalut.jpg';
                            }
                        }
                    } else {
                        this.result_show = true;
                    }
                })
        },
        goStoreDetail(store_id, store_name, index) {
            this.params.store_id = store_id;
            this.params.store_name = store_name;
            this.params.store_list = this.store_list;
            this.params.more_btn = this.more_btn;
            this.params.more_count = this.more_count;
            this.params.elem_index = index;
            if (this.$router.history.current.fullPath == '/') {
                EventBus.$emit('set_params', this.params);
            } else if (this.$router.history.current.fullPath == '/nearby') {
                EventBus.$emit('set_params_nearby', this.params);
            } else if (this.$router.history.current.fullPath == '/station') {
                EventBus.$emit('set_params_station', this.params);
            } else if (this.$router.history.current.fullPath == '/area') {
                EventBus.$emit('set_params_area', this.params);
                // 2021-01-14 코드수정 및 추가
            }else if (this.$router.history.current.fullPath == '/search') {
                EventBus.$emit('set_params_search', this.params);
            }

            // this.params.scrollY = // 스크롤 데이터
            // common.setParams(this.params);
            // EventBus.$emit('detail-data', this.params);
            // this.$router.push('/detail');

        },

    }
}
</script>



// WEBPACK FOOTER //
// src/components/component/VerticalListComponent.vue